import React, { useState, useEffect } from 'react'
import { Form, Select, Spin } from "antd";
import ModalComponent from "../../../components/global/modal/ModalComponent.jsx";
import toast from "react-hot-toast";
import { V2fxCredentialsManageApi } from "../../../api/request/client.js";
import { GetTraderAccountsByIdApi } from '../../../api/request/client.js'
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";

function V2fxLoginDetails({ v2fxLoginDetails, setV2fxLoginDetails, id }) {
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState({ terminalID: null, passType: null })
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isAccountLoading, setIsAccountLoading] = useState(false);

  const getTraderAccounts = async () => {
    try {
      setIsAccountLoading(true);
      let params = {
        FilterText: 'Approved',
        ApplyPagination: false,
        tradingAccountType: 0
      }
      const { data } = await GetTraderAccountsByIdApi(id, new URLSearchParams(params).toString());
      if (data?.success) {
        setData(data?.data?.map((item) => ({ ...item, value: item?.terminalID, label: item?.terminalID })));
      }
      setIsAccountLoading(false);
    } catch (error) {
      setIsAccountLoading(false);
    }
  }

  useEffect(() => {
    getTraderAccounts();
  }, []);


  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const { data } = await V2fxCredentialsManageApi(values);
      if (data?.success) {
        toast.success(data?.message);
        setV2fxLoginDetails(false);
        form.resetFields();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!V2fxLoginDetails) {
      form.resetFields();
      setV2fxLoginDetails(false);
    };
  }, [V2fxLoginDetails]);

  return (
    <div>
      <ModalComponent isOpen={v2fxLoginDetails} setIsOpen={setV2fxLoginDetails} title="Vertex Login Details" width={500}>
        {
          isAccountLoading ? (
            <div className="flex justify-center flex-col my-[20%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>
            </div>
          ) : (
            <Form className='w-full flex flex-col gap-5' autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
              <div className='ant-select-selector-white'>
                <label className='text-base text-[#2F2B3DCC] font-medium'>Select Account</label>
                <Form.Item name="terminalID" rules={[{ required: true, message: 'Please select a account.' }]}>
                  <Select placeholder="Select account" className="w-full mt-1" options={data} />
                </Form.Item>
              </div>
              <div className='ant-select-selector-white '>
                <label className='text-base text-[#2F2B3DCC] font-medium'>Select Password Type</label>
                <Form.Item name="passType" rules={[{ required: true, message: 'Please select a password type.' }]}>
                  <Select placeholder="Select password type" className="w-full mt-1" options={[{ value: "resend", label: "Resend" }, { value: "change", label: "Change" }]} />
                </Form.Item>
              </div>

              <div className='flex justify-end mt-5'>
                <div className="flex gap-3">
                  <button type='button' onClick={() => setV2fxLoginDetails(false)} className='bg-secondary text-sm text-white font-semibold rounded-lg px-6 py-2 '>Cancel</button>
                  <LoadableButton
                    type='submit' className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2'
                    disabled={isLoading}
                    lable="Proceed"
                    isLoading={isLoading}
                    loadingLable="Proceeding..."
                  />
                </div>
              </div>
            </Form>
          )
        }
      </ModalComponent>
    </div>
  )
}

export default V2fxLoginDetails;
